'use strict';

module.exports = require('./knn');


/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-knn/src/index.js
 ** module id = 101
 ** module chunks = 0
 **/